import { responsiveTokenVars } from '@tundr/ds-tokens';
import { responsiveTokens } from '@tundr/ds-tokens/internal';

/**
 * Contract-based shape variables resolved at runtime through the active theme.
 */
export const radiusVars = responsiveTokenVars.borderRadius;
export const borderWidthVars = responsiveTokenVars.borderWidth;

/**
 * Literal shape values from the DS token source.
 */
export const radiusScale = responsiveTokens.borderRadius;
export const borderWidthScale = responsiveTokens.borderWidth;

export type RadiusToken = keyof typeof radiusScale;
export type BorderWidthToken = keyof typeof borderWidthScale;

export const getRadius = (token: RadiusToken): string => radiusScale[token];
export const getBorderWidth = (token: BorderWidthToken): string =>
  borderWidthScale[token];
